import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import './AuthPages.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export default function ConfirmEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Ссылка недействительна');
      return;
    }

    fetch(`${API_URL}/auth/verify-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setStatus('success');
          setMessage('Email подтверждён!');
        } else {
          setStatus('error');
          setMessage(data.error || 'Ошибка');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Ошибка соединения');
      });
  }, [token]);

  return (
    <div className="auth-centered">
      <div className="auth-icon">
        {status === 'loading' ? '⏳' : status === 'success' ? '✅' : '❌'}
      </div>
      <h2 className="auth-heading">
        {status === 'loading' ? 'Проверяем...' : status === 'success' ? 'Готово!' : 'Ошибка'}
      </h2>
      <p className="auth-text">{message}</p>
      <div style={{ height: 24 }} />
      {status !== 'loading' && (
        <Button variant="blue" style={{ width: '80%' }} onClick={() => navigate('/login')}>
          Войти
        </Button>
      )}
    </div>
  );
}
